import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';

export const screenSizeResolverResolver: ResolveFn<string> = (route, state) => {
  const isMobile = window.innerWidth < 768;

  return of(isMobile ? 'mobile' : 'desktop');
};
